import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, Row, Modal } from 'react-bootstrap';
import { Check, RotateCw } from 'react-feather';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import NotyfContext from '../../contexts/NotyfContext';
import { blankUploadDocument, fetchUploadedDocument, setSkipDocuments, uploadDocument } from '../../redux/slices/UploadDocumentSlice';
import Loader from '../../components/Loader';
import Dropzone from '../../components/dropzone/Dropzone';
import Cropper from 'react-easy-crop';
import getCroppedImg from '../../components/cropImage';
import { callUserActvity, fetchNotification, setNotifcationBedge } from '../../redux/slices/CommonSlice';
import OnboardingSteps from '../../components/new/OnboardingSteps';
import RotateIcon from '../../assets/img/rotate-solid.svg';
import { fetchTourProgresses, updateTourProgress } from '../../redux/slices/TourProgressSlice';
import Joyride from 'react-joyride';
import ID from './dl-example.png';
import POA from './poa-example.png';
import SS from './ss-example.png';
import InfoPopover from '../../components/new/InfoPopover';

const UploadDocument = () => {
  const handleBeforeUnload = event => {
    // Display a confirmation dialog
    event.preventDefault();
    event.returnValue = 'Are you sure you want to leave this page?';
  };

  useEffect(() => {
    // Attach the event listener to the window object
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []); // Empty dependency array ensures the effect runs only once

  const notyf = useContext(NotyfContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [driverLicenseFile, setDriverLicenseFile] = useState(null);
  const [socialSecurityFile, setSocialSecurityFile] = useState(null);
  const [proofOfAddress, setProofOfAddressFile] = useState(null);

  const uploadDocumentStatus = useSelector(state => state.uploadDocument.status);
  const uploadDocumentData = useSelector(state => state.uploadDocument.uploadDocumentData);
  const uploadDocumentFile = useSelector(state => state.uploadDocument.uploadDocument);
  const error = useSelector(state => state.uploadDocument.error);
  // Tour Progresses
  const tourStatus = useSelector(state => state.tourProgress.status);
  const tours = useSelector(state => state.tourProgress.tours);

  useEffect(() => {
    if (tourStatus === 'idle') dispatch(fetchTourProgresses());
  }, [tourStatus]);

  useEffect(() => {
    if (tours.filter(tour => tour.tour_name === 'upload-document' && tour.completed).length === 0) setRun(true);
    else if (['loading', 'idle'].includes(tourStatus)) setRun(false);
    else setRun(false);
  }, [tours, tourStatus]);
  const [run, setRun] = React.useState(false);
  const customJoyrideStyles = {
    options: {
      // Change the font size of the content in the tooltip
      textColor: 'var(--bs-dark-blue)', // Change the text color (optional)
      zIndex: 1000, // Change the z-index (optional)
    },
    tooltip: {
      // Change the font size of the content in the tooltip
      fontSize: '18px',
      fontWeight: '500',
    },
  };

  const steps = [
    {
      target: '.first-step',
      content: (
        <>
          {' '}
          <p>The Credit Bureaus and Creditors require you to show proof of your identity before they will investigate your disputes.</p>
          <p> In order to expedite your disputes without delays, we provide them with a copy of all three of the following documents: Proof of Identity, Proof of Social, and Proof of Address.</p>
        </>
      ),
      disableBeacon: true,
      placement: 'center',
    },
    {
      target: '.second-step',
      content: (
        <>
          <h3 className='text-danger'>IMPORTANT!</h3>
          <p>Please make sure your ID can be seen clearly in the image you are about to submit! See example below!</p>
          <img src={ID} className='img-fluid mb-3' />
          <p>This will absolutely, 100%, emphatically, without a doubt prevent you from getting results. I cannot express to you enough how important it is that this is clear and all sides are visible</p>
        </>
      ),
      disableBeacon: true,
      placement: 'center',
    },
    {
      target: '.second-step-two',
      content: (
        <>
          <h3>Acceptable Identification Documents</h3>
          <ul className='text-start'>
            <li>Copy of driver's license</li>
            <li>Copy of passport</li>
            <li>Copies of court documents for legal name change</li>
            <li>Copy of birth certificate with current name</li>
            <li>Copy of marriage certificate with current name</li>
            <li>Copy of military ID</li>
          </ul>
        </>
      ),
      disableBeacon: true,
      placement: 'center',
    },
    {
      target: '.third-step',
      content: (
        <>
          <h3 className='text-danger'>VERY IMPORTANT!</h3>
          <p>Please make sure your Social Security can be seen clearly in the image you are about to submit! See example below!</p>
          <img src={SS} className='img-fluid mb-3' />
          <p>This will also indubitably absolutely, 100%, emphatically, without a doubt prevent you from getting results. I cannot express to you enough how important it is that this is clear and all sides are visible</p>
        </>
      ),
      disableBeacon: true,
      placement: 'center',
    },
    {
      target: '.third-step-two',
      content: (
        <>
          <h3>Acceptable Social Security Documents</h3>
          <ul className='text-start'>
            <li>Copy of pay stub with full Social Security number</li>
            <li>Copy of W-2 form with full Social Security number</li>
            <li>Copy of a valid Social Security card</li>
          </ul>
        </>
      ),
      disableBeacon: true,
      placement: 'center',
    },
    {
      target: '.fourth-step',
      content: (
        <>
          <h3 className='text-danger'>ALSO VERY IMPORTANT!</h3>
          <p>Notice a pattern?</p>
          <p>Please make sure your Proof of Address is of your CURRENT address and can be seen clearly in the image you are about to submit! See example below!</p>
          <img src={POA} className='img-fluid mb-3' />
          <p>This will also for sure prevent you from getting results. I cannot express to you enough how important it is that this is clear and all sides are visible</p>
        </>
      ),
      disableBeacon: true,
      placement: 'center',
    },
    {
      target: '.fourth-step-two',
      content: (
        <>
          <h3>Acceptable Proof of Address Documents</h3>
          <ul className='text-start'>
            <li>Copy of driver’s license or government-issued ID card</li>
            <li>Copy of Rental/lease agreement</li>
            <li>Copy of house deed</li>
            <li>Copy of mortgage or bank statement</li>
            <li>Copy of utility bill (e.g. electric, gas, telephone)</li>
            <li>Copy of W-2 form with correct address</li>
          </ul>
        </>
      ),
      disableBeacon: true,
      placement: 'center',
    },
    {
      target: '.fifth-step',
      content: (
        <>
          {' '}
          <p>Basically my point is that it is</p>
          <h3 className='text-danger'>EXTREMELY IMPORTANT!</h3>
          <p>That you take time to make sure that your documents are clear. The bureaus and creditors you are disputing with are NOT your friends. They are looking for any reason to reject your disputes.</p>
        </>
      ),
      disableBeacon: true,
      placement: 'center',
    },
  ];

  const handleJoyrideCallback = data => {
    const { type, status, index, action } = data;
    if (type === 'tour:end') dispatch(updateTourProgress({ tour_name: 'upload-document', completed: 1 }));
  };

  const [imagePath, setimagePath] = useState({
    imgDriverLicense: '',
    imgSocialSecurity: '',
    imgProofOfAddress: '',
  });

  const [imagePreview, setImagePreview] = useState({
    driverLicense: '',
    socialSecurity: '',
    proofOfAddress: '',
  });
  const [showImageModal, setShowImageModal] = useState({ show: false, type: '' });
  const [croppedAreaPixelsID, setCroppedAreaPixelsID] = useState(null);
  const [croppedAreaPixelsSS, setCroppedAreaPixelsSS] = useState(null);
  const [croppedAreaPixelsPOR, setCroppedAreaPixelsPOR] = useState(null);
  const [srcImgID, setSrcImgID] = useState(null);
  const [srcImgSS, setSrcImgSS] = useState(null);
  const [srcImgPOR, setSrcImgPOR] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);

  const showCroppedImageID = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(srcImgID, croppedAreaPixelsID, rotation);
      fetch(croppedImage).then(async response => {
        const contentType = response.headers.get('content-type');
        const blob = await response.blob();
        let filename = new Date().valueOf();
        const file = new File([blob], `${filename}.jpg`, { contentType });
        const imagePreviewOri = { ...imagePreview };
        setDriverLicenseFile(file);
        imagePreviewOri.driverLicense = URL.createObjectURL(file);
        setImagePreview(imagePreviewOri);
      });
      setShowImageModal({ show: false, type: '' });
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixelsID]);

  const showCroppedImageSS = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(srcImgSS, croppedAreaPixelsSS, rotation);
      fetch(croppedImage).then(async response => {
        const contentType = response.headers.get('content-type');
        const blob = await response.blob();
        let filename = new Date().valueOf();
        const file = new File([blob], `${filename}.jpg`, { contentType });
        const imagePreviewOri = { ...imagePreview };
        setSocialSecurityFile(file);
        imagePreviewOri.socialSecurity = URL.createObjectURL(file);
        setImagePreview(imagePreviewOri);
      });
      setShowImageModal({ show: false, type: '' });
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixelsSS]);

  const showCroppedImagePOR = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(srcImgPOR, croppedAreaPixelsPOR, rotation);
      fetch(croppedImage).then(async response => {
        const contentType = response.headers.get('content-type');
        const blob = await response.blob();
        let filename = new Date().valueOf();
        const file = new File([blob], `${filename}.jpg`, { contentType });
        const imagePreviewOri = { ...imagePreview };
        setProofOfAddressFile(file);
        imagePreviewOri.proofOfAddress = URL.createObjectURL(file);
        setImagePreview(imagePreviewOri);
      });
      setShowImageModal({ show: false, type: '' });
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixelsPOR]);

  const onCropCompleteSS = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixelsSS(croppedAreaPixels);
  }, []);

  const onCropCompleteID = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixelsID(croppedAreaPixels);
  }, []);

  const onCropCompletePOR = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixelsPOR(croppedAreaPixels);
  }, []);

  useEffect(() => {
    dispatch(fetchUploadedDocument());
  }, []);

  useEffect(() => {
    return () => {
      dispatch(blankUploadDocument());
    };
  }, []);

  useEffect(() => {
    if (uploadDocumentData && Object.keys(uploadDocumentData).length > 0) {
      if (uploadDocumentData.error === 0) {
        const basePath = document.body.dataset['app_base_url'];
        setImagePreview({
          driverLicense: uploadDocumentData.response.drivers_license ? basePath + uploadDocumentData.response.drivers_license : null,
          socialSecurity: uploadDocumentData.response.social_security ? basePath + uploadDocumentData.response.social_security : null,
          proofOfAddress: uploadDocumentData.response.proof_of_address ? basePath + uploadDocumentData.response.proof_of_address : null,
        });
      }
    }
  }, [uploadDocumentData]);

  useEffect(() => {
    if (uploadDocumentFile && Object.keys(uploadDocumentFile).length > 0) {
      if (uploadDocumentFile.error == 0) {
        notyf.open({
          type: 'success',
          message: 'Document uploaded successfully',
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
        dispatch(callUserActvity('Docuent uploaded with user onboard process'));
        dispatch(blankUploadDocument());
        setDriverLicenseFile(null);
        setSocialSecurityFile(null);
        setProofOfAddressFile(null);
        navigate('/mailing-option');
      } else {
        notyf.open({
          type: 'danger',
          message: uploadDocumentFile.msg,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
      }
    }
  }, [uploadDocumentFile]);

  const skipDocumentUpload = (skip) => {
    if(skip && ( (driverLicenseFile  && imagePreview.driverLicense) || (socialSecurityFile && imagePreview.socialSecurity) || (proofOfAddress && imagePreview.proofOfAddress) )){
      dispatch(setSkipDocuments(1))
    }else if( (driverLicenseFile  || imagePreview.driverLicense) && (socialSecurityFile || imagePreview.socialSecurity) && (proofOfAddress || imagePreview.proofOfAddress)){
      dispatch(setSkipDocuments(0))
    }else if (!driverLicenseFile || !socialSecurityFile || !proofOfAddress){
      dispatch(setSkipDocuments(1))
    } 
  }

  const handleSubmitDocument = () => {
    let message = '';
    if (!driverLicenseFile && !socialSecurityFile && !proofOfAddress && imagePreview.driverLicense && imagePreview.proofOfAddress && imagePreview.socialSecurity) {
      skipDocumentUpload()
      dispatch(blankUploadDocument());
      setDriverLicenseFile(null);
      setSocialSecurityFile(null);
      setProofOfAddressFile(null);
      navigate('/mailing-option');

      return;
    }else if (!driverLicenseFile && !socialSecurityFile && !proofOfAddress && !imagePreview.driverLicense && !imagePreview.proofOfAddress && !imagePreview.socialSecurity) {
      notyf.open({
        type: 'danger',
        message: "One or more documents required to continue",
        duration: '3000',
        ripple: false,
        dismissible: false,
        position: {
          x: 'right',
          y: 'top',
        },
      });
      return
    }else{
      const obj = {};
      if(driverLicenseFile) obj.drivers_license = driverLicenseFile;
      if(socialSecurityFile) obj.social_security = socialSecurityFile;
      if(proofOfAddress) obj.proof_of_address = proofOfAddress;
      skipDocumentUpload()
      dispatch(uploadDocument(obj));
      dispatch(fetchNotification());
      dispatch(setNotifcationBedge(true));
    }

  };

  const SUPPORTED_FORMATS = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'];

  const onDropID = useCallback(file => {
    setRotation(0);
    const fileData = file[0];
    const fileExtension = fileData.name.split('.').at(-1);
    if (SUPPORTED_FORMATS.includes(fileExtension)) {
      const reader = new FileReader();
      reader.addEventListener('load', () => setSrcImgID(reader.result));
      reader.readAsDataURL(file[0]);
      setShowImageModal({ show: true, type: 'ID' });
    } else {
      notyf.open({
        type: 'danger',
        message: 'Only png,jpg and jpeg allowed',
        duration: '3000',
        ripple: false,
        dismissible: false,
        position: {
          x: 'right',
          y: 'top',
        },
      });
    }
  });
  const onDropSS = useCallback(file => {
    setRotation(0);
    const fileData = file[0];
    const fileExtension = fileData.name.split('.').at(-1);
    if (SUPPORTED_FORMATS.includes(fileExtension)) {
      const reader = new FileReader();
      reader.addEventListener('load', () => setSrcImgSS(reader.result));
      reader.readAsDataURL(file[0]);
      setShowImageModal({ show: true, type: 'SS' });
    } else {
      notyf.open({
        type: 'danger',
        message: 'Only png,jpg and jpeg allowed',
        duration: '3000',
        ripple: false,
        dismissible: false,
        position: {
          x: 'right',
          y: 'top',
        },
      });
    }
  });
  const onDropPOR = useCallback(file => {
    setRotation(0);
    const fileData = file[0];
    const imagePreviewOri = { ...imagePreview };
    const fileExtension = fileData.name.split('.').at(-1);
    if (SUPPORTED_FORMATS.includes(fileExtension)) {
      const reader = new FileReader();
      reader.addEventListener('load', () => setSrcImgPOR(reader.result));
      reader.readAsDataURL(file[0]);
      setShowImageModal({ show: true, type: 'POR' });
    } else {
      notyf.open({
        type: 'danger',
        message: 'Only png,jpg and jpeg allowed',
        duration: '3000',
        ripple: false,
        dismissible: false,
        position: {
          x: 'right',
          y: 'top',
        },
      });
    }
  });
  const handleChange = (e, type) => {
    if (e.target.files && e.target.files.length > 0) {
      const fileExtension = e.target.files[0].name.split('.').at(-1);
      if (SUPPORTED_FORMATS.includes(fileExtension)) {
        if (type === 'driver_license') {
          setDriverLicenseFile(e.target.files[0]);
        }
        if (type === 'social_security') {
          setSocialSecurityFile(e.target.files[0]);
        }
        if (type === 'proof_of_address') {
          setProofOfAddressFile(e.target.files[0]);
        }
      } else {
        notyf.open({
          type: 'danger',
          message: 'Only png,jpg and jpeg allowed',
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
        if (type === 'driver_license') {
          setDriverLicenseFile(null);
        }
        if (type === 'social_security') {
          setSocialSecurityFile(null);
        }
        if (type === 'proof_of_address') {
          setProofOfAddressFile(null);
        }
      }
    }
  };
  const handleRotation = () => {
    let rotationOri = rotation;
    rotationOri += 90;
    if (rotation < 360) {
      setRotation(rotationOri);
    } else {
      setRotation(0);
    }
  };
  const basePath = document.body.dataset['app_base_url'];
  if (uploadDocumentStatus === 'loading') {
    return <Loader />;
  } else if (uploadDocumentStatus === 'failed') {
    notyf.open({
      type: 'danger',
      message: error,
      duration: '3000',
      ripple: false,
      dismissible: false,
      position: {
        x: 'right',
        y: 'top',
      },
    });
  }
  return (
    <React.Fragment>
      <Helmet title='Upload Document' />
      <style>
        {`
          .dropzone:hover {
            cursor: pointer;
          }
          .dropzone {
            padding: 3rem;
          }
          @media (max-width: 1284px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 600px !important;
                }
              }

              @media (max-width: 992px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 600px !important;
                }
              }

              @media (max-width: 768px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 600px !important;
                }
              }
              .react-joyride__tooltip-container {
                width: 100%;
  max-width: 600px; /* Set the desired width */
}


          `}
      </style>
      <Container fluid className='p-0 container-fluid-1335 fifth-step'>
        <Joyride showSkipButton={true} locale={{ last: 'FINISH' }} styles={customJoyrideStyles} steps={steps} run={run} continuous={true} scrollToFirstStep={true} showProgress={false} hideCloseButton disableOverlayClose={true} disableCloseOnEsc={true} callback={handleJoyrideCallback} />
        <OnboardingSteps activeStepButtonLeft='-2px' progressComplete='695px' activeStep={4} />
        <Row>
          <Col lg={8} className='pt-5 py-4'>
            <h3>Why do we need your personal identifying documents?</h3>
            <p className='text-dark-blue'>The Credit Bureaus and Creditors require you to show proof of your identity before they will investigate your disputes. In order to expedite your disputes without delays we provide them with a copy of all three of the following documents: Proof of Identity, Proof of Social, and Proof of Address.</p>
          </Col>
        </Row>
        <h3 className='py-4 first-step'>Please upload your documents here</h3>
        <Row>
          <Col md='4' sm='12'>
            <Card className='shadow border-0 p-2 mb-3 second-step second-step-two'>
              <Card.Body>
                <h3>
                  ID{' '}
                  <InfoPopover
                    headerContent={<h3 className='text-center'>Acceptable Identification Documents</h3>}
                    bodyContent={
                      <>
                        <ul className='text-start'>
                          <li>Copy of driver's license</li>
                          <li>Copy of passport</li>
                          <li>Copies of court documents for legal name change</li>
                          <li>Copy of birth certificate with current name</li>
                          <li>Copy of marriage certificate with current name</li>
                          <li>Copy of military ID</li>
                        </ul>
                      </>
                    }
                  />
                </h3>
                <Card className='mb-0'>
                  <Dropzone name='ID' onDrop={onDropID} image={imagePreview.driverLicense} accept={'image/*'} />
                </Card>
              </Card.Body>
            </Card>
          </Col>
          <Col md='4' sm='12'>
            <Card className='shadow border-0 p-2 mb-3 third-step third-step-two'>
              <Card.Body>
                <h3>
                  Social Security{' '}
                  <InfoPopover
                    headerContent={<h3 className='text-center'>Acceptable Social Security Documents</h3>}
                    bodyContent={
                      <>
                        <ul className='text-start'>
                          <li>Copy of pay stub with full Social Security number</li>
                          <li>Copy of W-2 form with full Social Security number</li>
                          <li>Copy of a valid Social Security card</li>
                        </ul>
                      </>
                    }
                  />
                </h3>
                <Card className='mb-0'>
                  <Dropzone name='Social Security' onDrop={onDropSS} image={imagePreview.socialSecurity} accept={'image/*'} />
                </Card>
              </Card.Body>
            </Card>
          </Col>
          <Col md='4' sm='12'>
            <Card className='shadow border-0 p-2 mb-3 fourth-step fourth-step-two'>
              <Card.Body>
                <h3>
                  Proof of Address{' '}
                  <InfoPopover
                    headerContent={<h3 className='text-center'>Acceptable Proof of Address Documents</h3>}
                    bodyContent={
                      <>
                        <ul className='text-start'>
                          <li>Copy of driver’s license or government-issued ID card</li>
                          <li>Copy of Rental/lease agreement</li>
                          <li>Copy of house deed</li>
                          <li>Copy of mortgage or bank statement</li>
                          <li>Copy of utility bill (e.g. electric, gas, telephone)</li>
                          <li>Copy of W-2 form with correct address</li>
                        </ul>
                      </>
                    }
                  />
                </h3>
                <Card className='mb-0'>
                  <Dropzone name='Proof of Address' onDrop={onDropPOR} image={imagePreview.proofOfAddress} accept={'image/*'} />
                </Card>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className='d-flex flex-row align-items-center gap-2 justify-content-between mt-4 mb-5'>
            <Button onClick={() => navigate('/verify-info')} variant='outline-primary' className='w-25'>
              Back
            </Button>

            <Button variant='secondary' className='w-md-25 w-50' onClick={() => {
              skipDocumentUpload(true)
              navigate('/mailing-option')
            }}>
              Skip & Upload Later
            </Button>

            <Button variant='primary' className='w-md-25 w-50' onClick={() => handleSubmitDocument()}>
              Save and Continue
            </Button>
          </Col>
        </Row>
      </Container>
      <Modal show={showImageModal.show} onHide={() => setShowImageModal({ show: false, type: '' })} backdrop='static' keyboard={false} size='lg'>
        <Modal.Header closeButton>Zoom and Crop Image</Modal.Header>
        <Modal.Body>
          {showImageModal.type === 'ID' ? (
            <div style={{ height: '400px', width: '70%' }}>
              <Cropper
                image={srcImgID}
                crop={crop}
                rotation={rotation}
                zoom={zoom}
                // maxZoom={1}
                // zoomWithScroll={true}
                // showGrid={true}
                aspect={16 / 9}
                onCropChange={setCrop}
                onRotationChange={setRotation}
                onCropComplete={onCropCompleteID}
                onZoomChange={setZoom}
                // cropSize = {{width:600,height:400}}
                // objectFit="horizontal-cover"
              />
            </div>
          ) : null}
          {showImageModal.type === 'SS' ? (
            <div style={{ height: '400px', width: '70%' }}>
              <Cropper
                image={srcImgSS}
                crop={crop}
                rotation={rotation}
                zoom={zoom}
                // maxZoom={1}
                // zoomWithScroll={true}
                // showGrid={true}
                aspect={16 / 9}
                onCropChange={setCrop}
                onRotationChange={setRotation}
                onCropComplete={onCropCompleteSS}
                onZoomChange={setZoom}
                // cropSize = {{width:600,height:400}}
                // objectFit="horizontal-cover"
              />
            </div>
          ) : null}
          {showImageModal.type === 'POR' ? (
            <div style={{ height: '400px', width: '70%' }}>
              <Cropper
                image={srcImgPOR}
                crop={crop}
                rotation={rotation}
                zoom={zoom}
                // maxZoom={1}
                // zoomWithScroll={true}
                // showGrid={true}
                aspect={16 / 9}
                onCropChange={setCrop}
                onRotationChange={setRotation}
                onCropComplete={onCropCompletePOR}
                onZoomChange={setZoom}
                // cropSize = {{width:600,height:400}}
                // objectFit="horizontal-cover"
              />
            </div>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <div className='controls'>
            <style>{`
            .controls {
  position: unset;
  display: flex;
  flex-direction: column;
  height: 100px;
  justify-content: center;
}
}
            `}</style>
            <label>
              Zoom Slider
              <input
                type='range'
                value={zoom}
                min={1}
                max={3}
                step={0.1}
                aria-labelledby='Zoom'
                onChange={e => {
                  setZoom(e.target.value);
                }}
                className='zoom-range'
              />
            </label>

            <br />
            <Button variant='primary' className=' ms-3 mt-md-3 w-100 w-md-75  d-flex align-items-center gap-3 justify-content-center' onClick={() => handleRotation()}>
              <img src={RotateIcon} alt='RotateIcon' width='25' /> Rotate Image
            </Button>
          </div>
        </Modal.Footer>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowImageModal({ show: false, type: '' })}>
            Close
          </Button>
          {showImageModal.type === 'ID' ? (
            <Button variant='primary' onClick={() => showCroppedImageID()}>
              Crop and Upload
            </Button>
          ) : showImageModal.type === 'SS' ? (
            <Button variant='primary' onClick={() => showCroppedImageSS()}>
              Crop and Upload
            </Button>
          ) : showImageModal.type === 'POR' ? (
            <Button variant='primary' onClick={() => showCroppedImagePOR()}>
              Crop and Upload
            </Button>
          ) : null}
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default UploadDocument;
